// src/odoo/customers/api/customerListApi.ts
// All comments are in English.

import { http } from "../../../core/http";

// ---------- Company list (for customers list page) ----------

export interface CustomerCompanyListItem {
  company_partner_id: number;
  company_name: string;
}

export interface CustomerCompanyListResponse {
  items: CustomerCompanyListItem[];
  page: number;
  page_size: number;
  total: number;
}

// Base path for company-level customer endpoints
const BASE_COMPANY = "/customers/company";

/**
 * Fetch paginated list of company-level customers.
 */
export async function fetchCustomerCompanies(params: {
  q?: string;
  page?: number;
  page_size?: number;
}): Promise<CustomerCompanyListResponse> {
  const res = await http.get<CustomerCompanyListResponse>(BASE_COMPANY, {
    params,
  });
  return res.data;
}
